import React from 'react';
import { View } from 'react-native';

import { Inline } from '@styleseat/ui';
import { BodyText, Touchable } from '../../../../ui';
import { SymbolsInstagramIcon } from '../../../../ui/Icons/SymbolsInstagramIcon';
import analytics from '../../../../../modules/analytics';

export function InstagramLink({
  username,
  providerId,
}: {
  username?: string,
  providerId: number,
}) {
  const handleClick = () => {
    analytics.track(
      'profile_instagram_username_click',
      {
        username,
        links_out: false,
        pro_id: providerId,
      },
    );
  };

  return !!username && (
    <Touchable onClick={handleClick}>
      <View>
        <Inline testID="instagram-link" alignItems="center" space={4} paddingBottom={4}>
          <SymbolsInstagramIcon width={14} height={14} />
          <BodyText appearance="small">@{username}</BodyText>
        </Inline>
      </View>
    </Touchable>
  );
}
